import PropTypes from "prop-types";
import React from "react";
import styles from "./styles.module.scss";

const Dots = ({ value, count }) => {
  const maxDots = 5;
  const desiredDotCountLeft = (maxDots - 1) / 2;
  const desiredDotCountRight = (maxDots - 1) / 2;
  const dotCountLeft = value;
  const dotCountRight = count - (value + 1);
  let missingDotCountLeft = desiredDotCountLeft - dotCountLeft;
  if (missingDotCountLeft < 0) missingDotCountLeft = 0;

  let missingDotCountRight = desiredDotCountRight - dotCountRight;
  if (missingDotCountRight < 0) missingDotCountRight = 0;

  return (
    <div className={styles.dots}>
      {Array.from(Array(desiredDotCountLeft + missingDotCountRight)).map(
        (_, i, array) => {
          const dotNumber = array.length - i;
          if (dotCountLeft < dotNumber) return null;
          // eslint-disable-next-line react/no-array-index-key
          return <div key={`dot-${i}`} className={styles.dot} />;
        }
      )}
      <div className={styles.activeDot} />
      {Array.from(Array(desiredDotCountRight + missingDotCountLeft)).map(
        (_, i) => {
          const dotNumber = i + 1;
          if (dotCountRight < dotNumber) return null;
          // eslint-disable-next-line react/no-array-index-key
          return <div key={`activeDot-${i}`} className={styles.dot} />;
        }
      )}
    </div>
  );
};

Dots.propTypes = {
  count: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default Dots;
